import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from 'app/@core/services/base.service';
import { UtilitiesService } from 'app/@core/services/utilities.service';
import { IPreferenceJson } from 'app/shared/interfaces/companyData.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @ViewChildren('stopSection') stopSections!: QueryList<ElementRef>;
  @ViewChild('scrollContainer', { static: true }) scrollContainer!: ElementRef<HTMLDivElement>;
  secondaryRefTypesData: any;
  timeZone: string;
  selectedTimeZone: string;
  @Input()
  set refNumber(value: string) {
    this.referenceNumber = value;
    this.getProgressBarHeaderData();
    this.getProgressbarData(value);

  }
  // ---------------------------------------- Component Properties ------------------------------------------- 
  referenceNumber!: string;
  activeStopIndex = 0;
  isCollapsed: boolean = false;
  isDetailedView!: boolean;
  event: any;
  refrenceNumber!: string | Number | null;
  shipmentRefrenceNumber: any;
  loadId!: string | number;
  companyLogoUrl: string;
  actualWidth: string;
  isScrollable: boolean;
  showLeft = false;
  showRight = false;
  statusData: any;
  currentDate: Date = new Date();
  events: any;
  companyData: IPreferenceJson;
  errorMessage: string;
  loading: boolean;
  progressBarData: any[];
  updatedEnroute: any;
  latestEnrouteEvent: any;
  constructor(private router: Router, private baseService: BaseService, private spinner: NgxSpinnerService, private toastr: ToastrService,private utilityService:UtilitiesService) { }

  // ---------------------------------------------Component Lifecycle Hooks ------------------------------------------------------
  ngOnInit(): void {
    const companyPrefrences = localStorage.getItem('companyPrefrences');
    if (companyPrefrences) {
      this.companyData = JSON.parse(companyPrefrences);
    }
    // Get Shipment Number From Session Storage For Persistance 
    const shipmentRefNumber = sessionStorage.getItem('shipmentRefrenceNumber');
    if (shipmentRefNumber) {
      this.refrenceNumber = JSON.parse(shipmentRefNumber);
    }

      // Subscribe first to always respond to changes in timezone
    this.utilityService.timeZone$.subscribe((zone: string) => {
      this.selectedTimeZone = zone;
    });
  }
  ngAfterViewInit() {
  }

  // --------------------------------------------- Public Methods -----------------------------------------------------

  getProgressBarHeaderData() {
    const secondaryTypes = localStorage.getItem('searchedShipments');
    if (secondaryTypes) {
      const shipmentSecondaryRefData = JSON.parse(secondaryTypes);
      const secondaryNumbersData = shipmentSecondaryRefData.find((item) => item.primaryReferenceNumber === this.referenceNumber);
      this.secondaryRefTypesData = secondaryNumbersData?.srNs;
    }
  }

  /**
   * Check If Step Completed
   */
  isStepCompleted(stopNumber: number) {
    // return this.shipmentEvents.some((event: any) => event.statusCode === statusCode)
    return this.events.events?.some((event: any) => event.stopNumber === stopNumber) || stopNumber < this.events.currentStopIndex;
  }

  isRecievedEvent(stopNumber: number) {
    // return this.shipmentEvents.some((event: any) => event.statusCode === statusCode)
    const filteredEvents = this.events.events?.filter((event: any) => event.stopNumber === stopNumber).filter(event => event.statusCode === 120 || event.statusCode === 140);;
    return filteredEvents;
  }

  isCircleCompleted(stopNumber: number) {
    // return this.shipmentEvents.some((event: any) => event.statusCode === statusCode)
    return this.events.events?.some((event: any) => event.stopNumber === stopNumber);
  }

  getProgressbarData(shipmentRefNumber: any) {
    // Join Two Apis to Execute in Parallel
    this.spinner.show(undefined,
      {
        type: 'ball-scale-multiple',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      }
    );
    this.loading = true;
    return forkJoin({
      progressbarStructure: this.baseService.getShipmentProgressbarStructureData(shipmentRefNumber),
      shipmentEvents: this.baseService.getShipmentProgreebarEvents(shipmentRefNumber),
      secondaryReferenceNumbers: this.baseService.getShipmentStatus(shipmentRefNumber)
    }).pipe(
      finalize(() => {
        this.spinner.hide();
      })
    ).subscribe({
      next: (response) => {
        this.shipment = response.progressbarStructure;
        this.events = response.shipmentEvents;
        this.statusData = response.secondaryReferenceNumbers.data;
        this.createProgressBar();
      },
      error: (err) => {
        this.spinner.hide();
        this.loading = false;
        this.shipment = null;
      },
      complete: () => {
        this.spinner.hide();
        this.loading = false;
      }
    })
  }
  shipment: any;

  /**
    * Create Final Stops Array
   */
  createProgressBar() {
  const shipment: any = [];
    this.shipment.stops.forEach((stop: any, index: number) => {
      const stopEvents = this.events.events.filter((event: any) => event.stopNumber === stop.stopNumber);
      const arrivedEvent = stopEvents.find((event: any) => event.taStatusDescription.toLowerCase().includes('arrive'));
      const departEvent = stopEvents.find((event: any) => event.taStatusDescription.toLowerCase().includes('depart'));
      const completeEvent = this.events.events.find((event: any) => event.taStatusCode === 190);
      let status = 'pending';
      let mergedEvent: any = {};
      if (departEvent) {
        status = 'depart';
        mergedEvent = departEvent;
      } else if (arrivedEvent) {
        status = 'arrived';
        mergedEvent = arrivedEvent;
        mergedEvent['eventLat']=arrivedEvent?.latitude,
        mergedEvent['eventLong']=arrivedEvent?.longitude
      } else if (completeEvent&&index===this.shipment?.stops.length-1) {
        status = 'completed';
        mergedEvent = completeEvent;
      }
      const stopData = {
        ...mergedEvent,
        ...stop,
        address: mergedEvent.address,
        status
      };

      shipment.push(stopData);
    });
    this.progressBarData = shipment;
  }

  /**
  * Show Enroute On Condition 
  */
  shouldShowEnRoute(index: number, stopNumber: number): boolean {
    // return index === this.events.currentStopIndex && index < this.shipment.stops.length - 1 && index > 0 && this.checkEnrouteEvent(stopNumber);
    this.latestEnrouteEvent = this.events.events[0]; // Assuming this is the most recent event

    const isEnroute =
      this.latestEnrouteEvent?.taStatusDescription?.toLowerCase().includes('en route') &&
      this.latestEnrouteEvent?.stopNumber === stopNumber;

    return isEnroute;
  }


  /**
   *Check the enroute event we get against any specific stop 
  */
  checkEnrouteEvent(stopNumber: number): boolean {
    const enrouteEvents = this.events.events.filter((event: any) => event.stopNumber === stopNumber);
    // this.latestEnrouteEvent = enrouteEvents.find((event: any) => event.taStatusCode === 110);
    this.latestEnrouteEvent = enrouteEvents.find((event: any) => event.taStatusDescription.toLowerCase().includes('en route'));
    return this.latestEnrouteEvent;
  }

  /**
   * Store shipment ref number to session storage on change 
   */
  onReferenceNumberChange() {
    sessionStorage.setItem('shipmentRefrenceNumber', JSON.stringify(this.refrenceNumber));
  }

  /**
   * Reset Ref Number
   */
  resetRefNumber(): void {
    sessionStorage.removeItem('shipmentRefrenceNumber');
    this.refrenceNumber = null;
  }

  navigateToLogin() {
    const companyName = this.companyData.nickName;
    this.router.navigateByUrl(`/customer-login/${companyName}`);
  }

  copyCoordinates(lat: number, lng: number) {
    if (lat && lng) {
      const coords = `${lat}, ${lng}`;
      navigator.clipboard.writeText(coords).then(() => {
        this.toastr.success('Coordinates copied to clipboard!');
      }).catch(() => {
        this.toastr.error('Failed to copy coordinates.');
      });
    } else {
      this.toastr.warning('Coordinates not available.');
    }
  }
  /**
   * Get Shipment Current Status 
   */
  get shipmentStatus(): string | null {
    return (this.events.events.length ? (this.events?.currentStatus) : this.shipment.currentStatus) || 'NA';
  }

  getTimediff(appTime: any, arrTime: any) {
    // parse and get ms since epoch (append 'Z' so it's UTC)
    const apptMs = new Date(`${appTime}Z`).getTime();
    const arrivalMs = new Date(`${arrTime}Z`).getTime();

    // difference in minutes
    const diffMinutes = (arrivalMs - apptMs) / 60000;
    return diffMinutes;

  }  // ----------------------------------------- Get two Gps Locations Difference -----------------------------------------------------------------
  /** Convert degrees → radians */
  private toRad(deg: number): number {
    return deg * Math.PI / 180;
  }

  /** 
   * Returns distance between two GPS points in miles 
   * using the Haversine formula.
   */
  getDistanceMiles(
    lat1: number, lon1: number,
    lat2: number, lon2: number
  ): number {
    const R = 3958.8; // earth radius in miles
    const dLat = this.toRad(lat2 - lat1);
    const dLon = this.toRad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(this.toRad(lat1))
      * Math.cos(this.toRad(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }
  /**
 * Returns true if the distance between stop and event 
 * is ≤ 0.5 miles.
 */
  isWithinHalfMile(step: any): boolean {
    if (step.latitude == null || step.longitude == null
      || step.eventLat == null || step.eventLong == null) {
      return false;
    }
    return this.getDistanceMiles(
      step.latitude, step.longitude,
      step.eventLat, step.eventLong
    ) <= 0.5;
  }
 isShipmentCompleted(){
   return this.events?.events?.some((event: any) => event.taStatusCode === 190) || false;
  }
}
